module.exports = __webpack_public_path__ + "img/MTABAPPTBI.e40525d1.jpg";